import React from 'react';
import PropTypes from 'prop-types';
import _fp from 'lodash/fp';
// import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import RouteCollection from '@bd/bdcore-named-routes';
import { Slugify } from '@bd/bdcore-utilities';
import PageMenu from '../../PageMenu';
import LightBoxPhotoList from '../../LightBoxPhotoList';
import { colors } from '../../../styles';


const styles = css`
.PhotoGallery_categoryTitle {
  font-weight: 800;
  font-size: 24px;
  color: ${colors.body};
  letter-spacing: 4px;
  text-align: center;
  line-height: 36px;
  text-transform: uppercase;
  margin: 40px 0 80px 0;
  position: relative;
  @media (min-width: 992px) {
    font-size: 41px;
    margin: 0 0 80px 0;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 150px;
    height: 3px;
    left: 50%;
    margin-left: -75px;
    background-color: ${colors.neutral};
    bottom: -40px;
  }
}
.PhotoGallery_categoryPostTitle {
  font-weight: 300;
  color: ${colors.brand1};
}
.PhotoGallery_menu {
  @media (min-width: 992px) {
    background-color: transparent;
    padding: 30px 0 60px 0;
    ul {
      text-align: center !important;
      li a {
        color: ${colors.brand1Dark} !important;
        line-height: 30px !important;
        height: 29px;
        margin: 0 30px;
        border-radius: 14px;
        text-transform: none;
        font-size: 14px;
        font-weight: 700;
        margin: 0 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        border: 0 !important;
        &.active {
          color: ${colors.white} !important;
          background-color: ${colors.brand2} !important;
          border: 0 !important;
        }
      }
    }
  }
}
`;

function PhotoGallery({ content = [], router, dataKey }) {
  const searchParams = new URLSearchParams(window.location.search);
  const searchParamSlug = searchParams.has(dataKey)
    ? Slugify(searchParams.get(dataKey))
    : undefined;
  const route = RouteCollection.getRouteByPath(_fp.get('location.pathname', router));
  const gallerySlug = _fp.getOr(searchParamSlug, `params.${dataKey}`, route);
  let activeGallery;
  let photos = [];

  if (gallerySlug) {
    activeGallery = content
      .find(g => Slugify(_fp.getOr('', 'category_name', g)) === gallerySlug);
    photos = _fp.getOr([], 'category_photos', activeGallery);
  } else {
    photos = _fp.flow(
      _fp.map('category_photos'),
      _fp.flatten,
    )(content);
  }

  const routeHasParam = _fp.some(Boolean, _fp.map(`keys.${dataKey}`, RouteCollection.getRoutes()[route.name]));
  const encode = !routeHasParam ? encodeURIComponent : v => v;

  const categoryLinks = content.map(g => ({
    name: route.name,
    [routeHasParam ? 'params' : 'query']: { [dataKey]: encode(_fp.get('category_name', g)) },
    title: _fp.get('category_name', g),
    hash: `#${dataKey}`,
  }));

  return (
    <div className={styles}>
      <PageMenu
        className="PhotoGallery_menu"
        title="Photo Gallery Categories"
        items={[
          {
            name: route.name,
            title: 'All Photos',
            hash: `#${dataKey}`,
          },
        ].concat(categoryLinks)}
      />
      <div className="container">
        <div className="row">
          <div className="col-12 pb-5">
            <LightBoxPhotoList
              show={12}
              gallery={_fp.get('category_name', activeGallery)}
              photos={photos}
              enableZoom
            />
          </div>
        </div>
      </div>
    </div>
  );
}

PhotoGallery.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  router: PropTypes.object.isRequired,
  dataKey: PropTypes.string.isRequired,
};

export default withData({
  router: true,
})(PhotoGallery);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PhotoGallery.section.js